import { authHeader } from "../../../../../auth";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {      
                ckfinder: {
                    uploadUrl: this.$serverURL + this.$api.editor.uploadFileURL
                }
            },
            setURL: this.$serverURL + this.$api.cms.home.heroSection.singleSlider,
            id: this.$route.params.id,
            previewImage: "",
            previewIcon: "",
            singleProject: {},
        }

    },
    async mounted() {
        await this.getSliderData();
    },
    methods: {
        uploadSliderImage: function (event) {
            this.singleProject.image = event.target.files[0];
            let input = this.$refs.image;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewImage = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        uploadButtonIcon: function (event) {
            this.singleProject.buttonIcon = event.target.files[0];
            let input = this.$refs.buttonIcon;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.previewIcon = e.target.result
                }
                reader.readAsDataURL(file[0])
            }
        },
        validate() {
            if (!this.singleProject.title) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add slider title."
                })
                return false;
            }  else if (!this.singleProject.image) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add slider image."
                })
                return false;
            } else if (!this.singleProject.description) {
                this.$swal.fire({
                    icon: "error",
                    text: "Add slider description."
                })
                return false;
            }
            return true;
        },
        getSliderData: async function () {
            console.log(this.setURL + this.id)
            let config = {
                method: "GET",
                url: this.setURL + this.id,
                headers: {
                    "Authorization": authHeader()
                }
            }
            await this.$axios(config).then(async (response) => {
                if (response.status == 200) {
                    this.singleProject = await response.data.data[0];
                }
                else {
                    this.$swal.fire({
                        icon: "error",
                        text: "Failed! please try again."
                    });
                }
            }).catch(error => {
                this.$swal.fire({
                    icon: "error",
                    text: "Failed! please try again." + error
                });
            });
        },
        updateSlider: async function () {
            if (this.validate()) {
                try {
                    let formData = new FormData();
                    formData.append('title', this.singleProject.title)
                    formData.append('image', this.singleProject.image);
                    formData.append('description', this.singleProject.description);
                    formData.append('buttonText', this.singleProject.buttonText);
                    formData.append('buttonLink', this.singleProject.buttonLink);
                    formData.append('buttonIcon', this.singleProject.buttonIcon);
                    let config = {
                        method: 'PATCH',
                        url: this.setURL + this.singleProject.id,
                        data: formData,
                        headers: {
                            "Authorization": authHeader(),
                            "Content-Type": "multipart/form-data",
                        }
                    };
                    await this.updateDataToBackend(config);
                    this.$router.push("/sliders");
                } catch (error) {
                    this.$swal.fire({
                        icon: "error",
                        text: "Something went wrong. Please try again! " + error
                    });
                }
            }

        }
    },
}